import { type CloudFlareResult, type ProcessFileType, clientConfig } from "@quickpoint.me/shared";
import { nanoid } from "nanoid";



export async function uploadDatafileToCloudflare({ dataFile, jwt }: { dataFile: ProcessFileType, jwt: string }): Promise<CloudFlareResult> {
    const fileName = nanoid(26);
    const cloudFlareResult = await fetch(clientConfig.uploadDatafileUrl({ jwt, fileName }));
    if (cloudFlareResult.status === 402) {
        // tier storage cap — surfaced with a specific message upstream
        throw new Error("storage-limit");
    }
    if (!cloudFlareResult.ok) {
        throw new Error("Failed to get Cloudflare upload URL");
    }
    const preSignedUrl = await cloudFlareResult.text();

    try {
        const resStream: Response = await fetch(preSignedUrl, {
            method: "PUT",
            headers: {
                "If-Unmodified-Since": "Tue, 28 Sep 2021 16:00:00 GMT",
                "content-type": dataFile.fileType
            },
            body: dataFile.data
        });
        // a successful R2 presigned PUT returns 200 with an EMPTY body —
        // parsing it as JSON throws and marked every real upload as failed
        // (the test mock returned JSON, which hid this)
        if (!resStream.ok) {
            throw new Error("Failed to upload data file to Cloudflare");
        }
        return {
            result: {
                requireSignedURLs: false,
                uploaded: new Date().getTime().toString(),
                id: fileName,
                filename: dataFile.fileName
            },
            url: cloudFlareResult.url,
            success: true
        };
    } catch (e) {
        throw new Error(`Upload DataFile To Cloudflare Error: ${e instanceof Error ? e.message : String(e)}`);
    }
}

